export default function SqlTablesSection() {
  return (
    <div className="ad-card">

      {/* Header */}
      <div className="ad-card-header">
        <h5 className="ad-card-title">SQL Tables</h5>
      </div>

      {/* Scrollable Body */}
      <div className="ad-onboard-scroll" style={{ minHeight: "140px", maxHeight: "200px" }}>
        <div className="ad-empty">
          <p className="ad-empty-sub">Select a company to load tables</p>
        </div>
      </div>

    </div>
  );
}